module.exports = __webpack_public_path__ + "img/灵活的数据应用能力@2x.e6df87f8.png";